import { initializeApollo } from '../utils/apolloClient';

export const getSelectedFilters = (params, items, filters) => {
	let selectedFilters = [];

	Object.entries(params).forEach((filter) => {
		const values = filter[1].split(',');

		Object.entries(filters).forEach((filter) => {
			const taxonomy = filter[0];
			const foundItem = items[taxonomy].nodes.filter((item) => values.includes(item.slug));

			if (foundItem) {
				selectedFilters = [...selectedFilters, ...foundItem];
			}
		});
	});

	const postFilterType = params.post_type ? 'post_type' : 'type';
	const show = params[postFilterType] ? { name: postFilterType, value: params[postFilterType] } : {};

	return {
		filters: selectedFilters,
		show,
	};
};

export const getSearchFilters = async (query) => {
	const apolloClient = initializeApollo();

	const response = await apolloClient.query({
		query,
	});

	const { data: filterItems } = response;

	return filterItems;
};

export const getSearchResults = async (url) => {
	try {
		const queryParams = new URL(url).searchParams;
		const term = queryParams.get('term');

		if (term) {
			const payload = await fetch(url);
			const response = await payload.json();
			return response;
		}

		return {
			found_posts: 0,
			result: [],
		};
	} catch (error) {
		return { error };
	}
};

export const convertFiltersToQueryString = (filters) => {
	const filterSelection = filters.reduce((params, filter) => {
		const newParams = { ...params };
		const { name } = filter.taxonomy.node;
		const value = filter.slug;
		if (newParams[name]) {
			newParams[name].push(value);
		} else {
			newParams[name] = [value];
		}
		return newParams;
	}, {});

	const filterQuery = Object.entries(filterSelection).reduce((arr, [filterName, filterValues]) => {
		const qs = `${filterName}=${filterValues.join(',')}`;
		arr.push(qs);
		return arr;
	}, []);

	if (filterQuery.length > 0) {
		return filterQuery.join('&');
	}

	return '';
};
